import { IIconProps } from "@/components/icons/interface";

const DEFAULT_COLOR = "#1A1A1A";

const HpCloseIcon = ({ width, height, color }: IIconProps) => {
  const fillColor = color ?? DEFAULT_COLOR;
  return (
    <svg
      width={width ?? 24}
      height={height ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M5.19732 4.81179C5.00049 4.85624 4.85265 5.0068 4.81092 5.20635C4.78734 5.31701 4.80911 5.44762 4.86625 5.5483C4.88258 5.57823 5.92385 6.62585 8.09437 8.79547L11.2971 12L8.08984 15.2082C5.09754 18.2014 4.87986 18.4209 4.85355 18.4762C4.70843 18.7773 4.87804 19.1202 5.20639 19.1891C5.31795 19.2127 5.44675 19.1909 5.55106 19.132C5.57736 19.1175 6.72566 17.9755 8.79641 15.9057L12 12.7029L15.2046 15.9057C17.2744 17.9755 18.4227 19.1175 18.449 19.132C18.566 19.1982 18.7248 19.2154 18.849 19.1755C19.0377 19.1156 19.1746 18.9442 19.1973 18.7392C19.2046 18.6703 19.1819 18.5542 19.1474 18.4789C19.1193 18.42 18.996 18.2948 15.9102 15.2082L12.703 12L15.9057 8.79547C17.9756 6.72562 19.1175 5.57732 19.132 5.55102C19.1765 5.47302 19.1955 5.39955 19.1955 5.30612C19.1964 5.161 19.1502 5.04671 19.0504 4.94694C18.8935 4.79002 18.644 4.75646 18.4517 4.86621C18.4218 4.88254 17.3742 5.92381 15.2046 8.09433L12 11.2971L8.79641 8.09433C6.62589 5.92381 5.57827 4.88254 5.54834 4.86621C5.44947 4.80998 5.30616 4.7873 5.19732 4.81179Z"
        fill={fillColor}
      />
    </svg>
  );
};

export { HpCloseIcon };
